/*!

=========================================================
* Argon Dashboard React - v1.2.1
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/

// reactstrap components
import { useParams } from "react-router-dom";
import { Container } from "reactstrap";
import ExecutionInfoChapters from '../components/ExecutionInfoChapters';
import ExecutionInfoForm from "../components/ExecutionInfoForm";
import ExecutionInfoScreenshots from '../components/ExecutionInfoScreenshots';
import ExecutionInfoSubtitles from '../components/ExecutionInfoSubtitles';
import ExecutionInfoHeader from '../components/Headers/ExecutionInfoHeader';
import ExecutionUtterances from '../components/ExecutionUtterances';
import WordcloudSection from '../components/WordcloudSection';
import NERSection from '../components/NERSection'
import QnASection from '../components/QnASection'
import { useCurrentUser } from "../hooks/useCurrentUser";
import { UserPermissions } from "../types";
import { useExecutionInfo } from "../hooks/useExecutionInfo";

const ExecutionInfo: React.FC = () => {
  const { data: user } = useCurrentUser()
  const { id } = useParams<{ id: string }>()
  const { data: execInfo } = useExecutionInfo(id)

  return (
    <>
      <ExecutionInfoHeader id={id} />
      <Container className="mt--7" fluid>
        <ExecutionInfoForm id={id} />
        <br />
        <ExecutionInfoSubtitles id={id} />
        <br />
        {
          execInfo?.utternacesJSONUrl &&
          <>
            <ExecutionUtterances id={id} />
            <br />
          </>
        }
        <ExecutionInfoChapters id={id} />
        {
          user?.roles.includes(UserPermissions.qna) &&
          <>
            <QnASection id={id} />
            <br />
          </>
        }
        <NERSection id={id} />
        <WordcloudSection id={id} />
        <br />
        <ExecutionInfoScreenshots id={id} />
      </Container>
    </>
  );
};

export default ExecutionInfo;
